import {PrincipalFavoritePlaceEnum, PatchFavoritePlaceRequest, PredefinedFavoritePlacesEnum} from 'domain/usecases';
import {formatMasks} from 'presentation/utils';
import {PatchFavoritePlaceServiceParams} from '../types';
import {makePatchFavoritePlace} from 'main/factories/usecases';

export async function patchFavoritePlace({
  cdBeneficiarioEnderecoFavorito,
  data,
  signal,
}: PatchFavoritePlaceServiceParams) {
  const parsedData: PatchFavoritePlaceRequest = {
    nmLocal: data?.favoriteAddress?.trim() ?? PredefinedFavoritePlacesEnum.OTHER,
    nmLogradouro: data.address.trim().replace(/^(\w+)\./, '$1'),
    nuEndereco: Number(data.number),
    nmBairro: data.district.trim(),
    nmCidade: data.city.trim(),
    nmUf: data.state.trim(),
    nuCep: formatMasks('clear', data.zipCode),
    flPrincipal: PrincipalFavoritePlaceEnum.NO,
    dsComplemento: data.complement.trim(),
  };
  await makePatchFavoritePlace(cdBeneficiarioEnderecoFavorito).patch({...parsedData, signal});
}
